import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/lib/domGuard";
import "@/index.css";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import App from "@/App";

document.documentElement.setAttribute("dir", "rtl");
document.documentElement.setAttribute("lang", "ar");
document.documentElement.classList.add("dark");

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__rawajInstall = e;
  window.dispatchEvent(new Event("rawaj-install-ready"));
});
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </AppErrorBoundary>,
);
